import { Link } from "react-router-dom";
import { animeCategories } from "@/mocks/anime";

const categoryIcons: Record<string, string> = {
  热血: "ri-fire-line",
  恋爱: "ri-heart-3-line",
  奇幻: "ri-magic-line",
  科幻: "ri-rocket-line",
  校园: "ri-school-line",
  日常: "ri-sun-line",
  悬疑: "ri-spy-line",
  治愈: "ri-plant-line",
  冒险: "ri-compass-3-line",
  运动: "ri-basketball-line",
  搞笑: "ri-emotion-laugh-line",
};

export default function CategoryQuick() {
  return (
    <section className="w-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">分类快捷入口</h2>
          <p className="text-sm text-foreground-600 mt-1">按你的口味快速找到想看的类型</p>
        </div>
        <Link
          to="/category"
          className="text-sm text-primary-700 hover:text-primary-800 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-11 gap-3">
        {animeCategories.map((c) => (
          <Link
            key={c}
            to={`/category?category=${encodeURIComponent(c)}`}
            className="card-hover group flex flex-col items-center justify-center gap-2 py-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
          >
            <span className="w-11 h-11 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={categoryIcons[c] || "ri-apps-2-line"}></i>
            </span>
            <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">{c}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}